
//#region Imports
import { BaseService } from 'src/app/core/services/base-service.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfirmHealthInsuranceDto } from '../model/confirmHealthInsuranceDto';
import { MemberResponsePortalResponseDto } from '@app/core/models/memberResponsePortalResponseDto';

//#endregion Imports

@Injectable({
  providedIn: 'root'
})

export class ConfirmHealthInsuranceService extends BaseService {

    //#region Constructor
    constructor(http: HttpClient) {
        super(http);
    }
     //#endregion Constructor

    //#region Public Methods
    public Save(confirmHealthInsuranceRequestDto: ConfirmHealthInsuranceDto): Observable<MemberResponsePortalResponseDto> {
        return this.Post('/Response/HealthInsurance', confirmHealthInsuranceRequestDto);
    }
    //#endregion Public Methods
}
